import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

function normalizeTransformed(payload) {
  if (Array.isArray(payload) && (payload.length === 0 || typeof payload[0] === 'string')) {
    return payload;
  }
  if (Array.isArray(payload) && payload.length && payload[0] && typeof payload[0].value === 'string') {
    return payload.map((x) => x.value);
  }
  if (payload && Array.isArray(payload.transformed)) {
    return payload.transformed.filter((x) => typeof x === 'string');
  }
  return [];
}

class KeywordsService {
  getKeywords() {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.get(`${Config.api.tender.url}keywords`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  addCategory(category) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.post(`${Config.api.tender.url}keyword-categories`, category, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  deleteCategory(categoryId) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.delete(`${Config.api.tender.url}keyword-categories/${categoryId}`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  editCategory({ categoryId, category }) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.put(`${Config.api.tender.url}keyword-categories/${categoryId}`, category, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  editKeyword({ keywordId, keyword }) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.put(`${Config.api.tender.url}keywords/${keywordId}`, keyword, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  addKeywordsBulk(keywords) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.post(`${Config.api.tender.url}keywords/bulk`, keywords, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  deleteKeywordsBulk(ids) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.delete(
      `${Config.api.tender.url}keywords/bulk`,
      { data: ids },
      {
        cancelToken: cancelToken.token,
      },
    ).then((response) => response.data);
  }
  // target: 'tenders' (the API's default) or 'documents', whose keywords the documents search must be able to read
  transformKeywords(keywords, target) {
    if (cancelToken) cancelToken.cancel('Multiple requests.');
    cancelToken = CancelToken.source();

    return ApiService.post(`${Config.api.tender.url}keywords/generate`, target ? { keywords, target } : { keywords }, {
      cancelToken: cancelToken.token,
    }).then((response) => normalizeTransformed(response && response.data));
  }
}

export const keywordsService = new KeywordsService();
